import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAppQuery } from "shared/api/baseQuery";
import { ContactUs, ContactUsData, ContactUsFilter } from "features/lead/types/contact-us";
import { formatDateUi } from "shared/utils/converters";
import { snackbarOnQueryStarted } from "middleware/snackbarOnQueryStarted";

const ENDPOINT = "/lead-application";
const leadsApi: any = createApi({
  reducerPath: "leadsApi",
  baseQuery: baseAppQuery,
  tagTypes: ["leads"],
  endpoints: (builder) => ({
    getLeadApplicationList: builder.query<ContactUsData[], ContactUsFilter>({
      query: (filter) => {
        const queryParams = new URLSearchParams();
        if (filter) {
          queryParams.set("page", filter.pageNumber.toString());
          queryParams.set("size", filter.pageSize.toString());
          if (filter.name) queryParams.set("name", filter.name);
          if (filter.mobile) queryParams.set("mobile", filter.mobile);
          if (filter.email) queryParams.set("email", filter.email);
          if (filter.status) queryParams.set("status", filter.status);
          if (filter.dateFrom) {
            queryParams.set("fromDate", formatDateUi(filter.dateFrom));
          }
          if (filter.dateTo) {
            queryParams.set("toDate", formatDateUi(filter.dateTo));
          }
        }
        return `${ENDPOINT}/fetch-all?${queryParams}`;
      },
      providesTags: ["leads"],
    }),
    getLeadApplicationById: builder.query<ContactUsData, string>({
      query: (id) => `${ENDPOINT}/${id}`,
      providesTags: ["leads"],
    }),
    createLeadApplication: builder.mutation<ContactUsData, ContactUs>({
      query: (data) => ({
        url: ENDPOINT,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["leads"],
      onQueryStarted: snackbarOnQueryStarted({
        successMessage:"createLeadSuccess",
        errorMessage:"createLeadError",
      })
    }),
    updateLeadApplication: builder.mutation<ContactUsData, ContactUs>({
      query: (data) => ({
        url: ENDPOINT,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["leads"],
      onQueryStarted: snackbarOnQueryStarted({
        successMessage:"updateLeadSuccess",
        errorMessage:"updateLeadError",
      }),
    }),
  }),
});

export const {
  useGetLeadApplicationListQuery,
  useGetLeadApplicationByIdQuery,
  useCreateLeadApplicationMutation,
  useUpdateLeadApplicationMutation,
} = leadsApi;
export default leadsApi;
